import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertDisplay, AlertLevel, AlertType } from '@cds/angular';
import { take } from 'rxjs';
import { MFAModes } from 'src/app/enums/enums/mfa-modes.enum';
import { MfaOptInService } from 'src/app/services/mfa-opt-in.service';

@Component({
  selector: 'app-early-mfa',
  templateUrl: './early-mfa.component.html',
  styleUrl: './early-mfa.component.scss',
  standalone: false
})
export class EarlyMfaComponent {
  mfaTitle = 'Early MFA Setup';
  mfaSubtitle = `Starting September 1st, 2025, Multi-factor Authentication (MFA) will be mandatory in our web applications.`;
  mfaDescription = `
    You can get ahead of the game by setting up MFA now.

    Opting for early setup enhances security, ensures seamless transition, and prevents potential service disruptions.

    Alternatively, you can contact your account executive (AE) to set up Single Sign On (SSO), maximizing security and ease of login.`;

  mfaBtnSetup = 'Setup MFA';
  mfaBtnSkip = 'Skip, this time';

  mfaErrorDisplay = AlertDisplay.Toast;
  mfaErrorTitle = 'Something Has Gone Wrong';
  mfaErrorAlertType = AlertType.Primary;
  mfaErrorAlertLevel = AlertLevel.Error;
  mfaErrorIcon = 'error';
  mfaErrorMessage = `We've encountered a problem. Please try again later.`;

  showMFAErrorAlert = this.mfaOptInService.getHasMFAError();

  mfaState!: string;
  mfaDomain!: string;

  constructor(
    private readonly mfaOptInService: MfaOptInService,
    private readonly route: ActivatedRoute
  ) {
    document.documentElement.style.setProperty(
      '--color-interactive-01',
      '#0E57CC',
      'important'
    );
    document.documentElement.style.setProperty(
      '--color-hover-primary',
      '#126dff',
      'important'
    );

    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      this.mfaDomain = params['d'];
      this.mfaState = params['state'];
    });
  }

  setupMFA(): void {
    this.mfaOptInService.redirectToMFAFlow(
      this.mfaDomain,
      this.mfaState,
      MFAModes.SETUP
    );
  }

  skipMFASetup(): void {
    this.mfaOptInService.redirectToMFAFlow(
      this.mfaDomain,
      this.mfaState,
      MFAModes.SKIP
    );
  }

  closeMFAAlertError(): void {
    this.mfaOptInService.resetMFAError();
  }
}
